import React from "react";
import FAQs from "./FAQs";

const ContactSupport = () => {
  return (
    <div>
      <div className="sm:mx-2 py-4 mb-4 border-b border-content/40 border-dashed">
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-xl font-bold text-primary">FAQs</h1>
            <p className="text-sm text-muted mt-1">
              Find answers to common questions.
            </p>
          </div>
        </div>
      </div>

      <div className="sm:mx-2">
        <FAQs />
      </div>
    </div>
  );
};

export default ContactSupport;
